// Small helpers shared by the Notification Centre tabs.
export const AUDIENCE_LABEL = { customer: "Customer", admin: "Admin", staff: "Staff" };

export const CATEGORY_LABEL = {
    account: "Account", kyc: "KYC", booking: "Bookings", payment: "Payments", reminder: "Reminders",
    trip: "Trips", handover: "Delivery and pick-up", staff: "Staff", system: "System", general: "General",
};

// "booking.reminder.start_24h" -> "Booking reminder start 24h"
export const eventName = (key) => {
    const text = String(key || "").replace(/[._]/g, " ").trim();
    return text.charAt(0).toUpperCase() + text.slice(1);
};

export const STATUS_CLASS = {
    sent: "bg-success-subtle text-success", delivered: "bg-success-subtle text-success", read: "bg-success-subtle text-success",
    queued: "bg-warning-subtle text-warning-emphasis", sending: "bg-warning-subtle text-warning-emphasis",
    failed: "bg-danger-subtle text-danger", skipped: "bg-secondary-subtle text-secondary",
};

export const whenText = (value) => {
    if (!value) return "-";
    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";
    return date.toLocaleString("en-IN", { day: "numeric", month: "short", hour: "numeric", minute: "2-digit", hour12: true });
};
